The notice period that is required.
